import alibabaCloud from './alibaba-cloud.svg';
import amazon from './amazon.svg';
import amazonAws from './amazon-aws.svg';
import apple from './apple.svg';
import github from './github.svg';
import google from './google.svg';
import line from './line.png';
import microsoft from './microsoft.svg';
import wecom from './wecom.svg';
import workato from './workato.svg';

const brandIcons = {
  'alibaba-cloud': alibabaCloud,
  amazon,
  'amazon-aws': amazonAws,
  apple,
  github,
  google,
  line,
  microsoft,
  wecom,
  workato,
};

export default brandIcons;
